// Copyright (c) 2019 Deere & Company

import WearPartsClaim from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.claims.wearParts,
    allowedAccounts: state.user.details.settings.dealer.accounts.allowedAccounts,
    isCkcCustomerFailed: state.customerFailed.ckcCustomerFailed,
    latestPerUnitMeasurements: state.latestPerUnitMeasurements,
    partsGroupedByPartNumber: state.claims.partsGroupedByPartNumber,
    warranties: state.productDetails.warranties
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const queryParams = parentProps.location.query;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(WearPartsClaim);



// WEBPACK FOOTER //
// ./src/claim/wear-parts/state-connector.js